/* eslint-disable */
import asyncComponent from 'components/Async';

/**
 * Helper function wich tries to import a component based on the
 * path wich comes as parameter.
 * IMPORTANT: path must be inside the pages folder of the app
 *
 * @param {string} path the path to resolve the component to import
 * @returns {Component} a react component asynchronously imported
 */
export const generateComponent = (path) => asyncComponent(() => import(`views/${path}`));

/**
 * Triggers a file download from a binary HTTP response, or intercepts 202 Accepted / JSON
 * responses when a massive Excel export has been queued asynchronously in FastAPI + Nextcloud.
 *
 * @param {Response} httpResponse - Fetch HTTP response object
 * @param {string} filename - Target file name for synchronous binary downloads
 * @returns {Promise<Object|null>} Parsed JSON payload when queued, or null when downloaded
 */
export const fireDownloadFromResponse = async (httpResponse, filename) => {
  const contentType = (
    httpResponse
    && httpResponse.headers
    && typeof httpResponse.headers.get === 'function'
    && httpResponse.headers.get('content-type')
  ) || '';

  if (
    (httpResponse && httpResponse.status === 202)
    || contentType.includes('application/json')
  ) {
    let payload = {};
    try {
      payload = await httpResponse.json();
    } catch (error) {
      payload = { status: 'processing' };
    }
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new CustomEvent('erp:massive-export-queued', { detail: payload }));
    }
    return payload;
  }

  const blob = await httpResponse.blob();
  const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = filename;
  a.click();
  const { parentNode } = a;
  if (parentNode) {
    parentNode.removeChild(a);
  }
  return null;
};

export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onload = () => {
    resolve(reader.result);
  };
  reader.readAsDataURL(blob);
});
